import { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "stepLabelsVisible";

const StepLabelsContext = createContext({
    stepLabelsVisible: true,
    setStepLabelsVisible: () => {},
    toggleStepLabels: () => {},
});

export function StepLabelsProvider({ children }) {
    const [stepLabelsVisible, setStepLabelsVisibleState] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved === null ? true : saved === "true";
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, String(stepLabelsVisible));
    }, [stepLabelsVisible]);

    const setStepLabelsVisible = (value) => {
        setStepLabelsVisibleState(Boolean(value));
    };

    const toggleStepLabels = () => {
        setStepLabelsVisibleState((prev) => !prev);
    };

    return (
        <StepLabelsContext.Provider
            value={{ stepLabelsVisible, setStepLabelsVisible, toggleStepLabels }}
        >
            {children}
        </StepLabelsContext.Provider>
    );
}

export function useStepLabels() {
    return useContext(StepLabelsContext);
}
